import { render } from "./dispatch-page.vue?vue&type=template&id=483a710c&ts=true"
import script from "./dispatch-page.ts?vue&type=script&lang=ts"
export * from "./dispatch-page.ts?vue&type=script&lang=ts"

import "./dispatch-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__